var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      staticClass: "vip-dashboard",
      attrs: { "aria-busy": _vm.isLoading ? "true" : "false" },
    },
    [
      _c("div", { staticClass: "vip-profile-summary" }, [
        _c(
          "div",
          {
            staticClass: "vip-avatar",
            class: { "is-vip-zero": _vm.memberLevel === 0 },
          },
          [
            _vm.memberLevel === 0
              ? _c(
                  "span",
                  {
                    staticClass: "vip-avatar-zero",
                    attrs: { "aria-hidden": "true" },
                  },
                  [_vm._v("VIP0")]
                )
              : _vm.memberIconImage
              ? _c("img", {
                  attrs: {
                    src: _vm.memberIconImage,
                    alt: _vm.memberDisplayName,
                  },
                  on: {
                    error: function ($event) {
                      _vm.useFallbackMemberIcon = true
                    },
                  },
                })
              : _c("i", {
                  staticClass: "el-icon-user-solid",
                  attrs: { "aria-hidden": "true" },
                }),
          ]
        ),
        _c("div", { staticClass: "vip-profile-main" }, [
          _c("div", { staticClass: "vip-identity-row" }, [
            _c(
              "strong",
              {
                staticClass: "vip-level-name",
                attrs: { title: _vm.memberLevelName },
              },
              [
                _vm.levelNameParts.isVip
                  ? [
                      _vm._m(0),
                      _c("span", { staticClass: "vip-level-number" }, [
                        _vm._v(_vm._s(_vm.levelNameParts.suffix)),
                      ]),
                    ]
                  : _c("span", { staticClass: "vip-level-text" }, [
                      _vm._v(_vm._s(_vm.memberLevelName)),
                    ]),
              ],
              2
            ),
          ]),
          _c("div", { staticClass: "vip-progress-line" }, [
            _c(
              "div",
              {
                staticClass: "vip-profile-progress",
                attrs: {
                  role: "progressbar",
                  "aria-valuemin": "0",
                  "aria-valuemax": "100",
                  "aria-valuenow": _vm.memberProgressPercent,
                },
              },
              [
                _c("span", {
                  style: { width: _vm.memberProgressDisplayPercent + "%" },
                }),
              ]
            ),
            _vm.isMaxLevel
              ? _c("span", { staticClass: "vip-max-level-label" }, [
                  _c("i", {
                    staticClass: "el-icon-trophy",
                    attrs: { "aria-hidden": "true" },
                  }),
                  _vm._v(
                    "\n\t\t\t\t\t" +
                      _vm._s(_vm.$t("personalCenter.vip.max_level")) +
                      "\n\t\t\t\t"
                  ),
                ])
              : _c("span", { staticClass: "vip-next-level-label" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("personalCenter.vip.next_level", {
                        level: _vm.memberNextLevel,
                      })
                    )
                  ),
                ]),
          ]),
          _vm.isMaxLevel
            ? _c("p", { staticClass: "vip-progress-summary" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("personalCenter.vip.current_experience", {
                      current: _vm.formatMemberPoints(_vm.memberCurrentPoints),
                    })
                  )
                ),
              ])
            : _c("p", { staticClass: "vip-progress-summary" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("personalCenter.vip.experience_summary", {
                      current: _vm.formatMemberPoints(_vm.memberCurrentPoints),
                      level: _vm.memberNextLevel,
                      remaining: _vm.formatMemberPoints(
                        _vm.memberRemainingPoints
                      ),
                    })
                  )
                ),
              ]),
        ]),
        _c("div", { staticClass: "vip-profile-points" }, [
          _c("p", [
            _vm._v(
              _vm._s(_vm.$t("personalCenter.vip.points_label")) + "\n\t\t\t\t"
            ),
            _c("strong", [
              _vm._v(
                _vm._s(
                  _vm.isLoadingPointsBalance
                    ? "--"
                    : _vm.formatMemberPoints(_vm.pointsBalance)
                )
              ),
            ]),
          ]),
          _c(
            "button",
            { attrs: { type: "button" }, on: { click: _vm.goToPointsMall } },
            [_vm._v(_vm._s(_vm.$t("personalCenter.vip.go_redeem")))]
          ),
        ]),
      ]),
      _c(
        "section",
        { staticClass: "vip-reward-section" },
        [
          _c("div", { staticClass: "vip-reward-heading" }, [
            _c(
              "button",
              {
                staticClass: "vip-tier-arrow",
                attrs: {
                  type: "button",
                  disabled: _vm.selectedTierIndex === 0,
                  "aria-label": _vm.$t("personalCenter.vip.previous_level"),
                },
                on: {
                  click: function ($event) {
                    _vm.selectedTierIndex--
                  },
                },
              },
              [
                _c("i", {
                  staticClass: "el-icon-arrow-left",
                  attrs: { "aria-hidden": "true" },
                }),
              ]
            ),
            _c("div", { staticClass: "vip-reward-copy" }, [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("personalCenter.vip.level_rewards"))),
              ]),
              _c("div", { staticClass: "vip-reward-title-row" }, [
                _c(
                  "strong",
                  {
                    staticClass: "vip-level-name",
                    attrs: {
                      title: _vm.selectedTier.levelName,
                      "aria-label": _vm.selectedTier.levelName,
                    },
                  },
                  [
                    _vm.selectedTierNameParts.isVip
                      ? [
                          _vm._m(1),
                          _c("span", { staticClass: "vip-level-number" }, [
                            _vm._v(_vm._s(_vm.selectedTierNameParts.suffix)),
                          ]),
                        ]
                      : _c("span", { staticClass: "vip-level-text" }, [
                          _vm._v(_vm._s(_vm.selectedTier.levelName)),
                        ]),
                  ],
                  2
                ),
                _c("h3", [
                  _vm._v(
                    _vm._s(_vm.$t("personalCenter.vip.exclusive_rewards"))
                  ),
                ]),
              ]),
            ]),
            _c(
              "button",
              {
                staticClass: "vip-tier-arrow",
                attrs: {
                  type: "button",
                  disabled: _vm.selectedTierIndex === _vm.tiers.length - 1,
                  "aria-label": _vm.$t("personalCenter.vip.next_level_button"),
                },
                on: {
                  click: function ($event) {
                    _vm.selectedTierIndex++
                  },
                },
              },
              [
                _c("i", {
                  staticClass: "el-icon-arrow-right",
                  attrs: { "aria-hidden": "true" },
                }),
              ]
            ),
          ]),
          _vm.selectedTier.rewards.length
            ? _c(
                "div",
                { staticClass: "vip-reward-grid" },
                _vm._l(_vm.selectedTier.rewards, function (reward, index) {
                  return _c(
                    "article",
                    {
                      key: reward.id || reward.key || index,
                      staticClass: "vip-reward-item",
                    },
                    [
                      _c("div", { staticClass: "vip-reward-icon" }, [
                        reward.icon
                          ? _c("img", { attrs: { src: reward.icon, alt: "" } })
                          : _c("i", {
                              staticClass: "el-icon-present",
                              attrs: { "aria-hidden": "true" },
                            }),
                      ]),
                      _c("strong", [
                        _vm._v(_vm._s(_vm.getRewardLabel(reward))),
                      ]),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            reward.description ||
                              _vm.$t("personalCenter.vip.promotion_reward", {
                                level: _vm.selectedTier.level,
                              })
                          )
                        ),
                      ]),
                    ]
                  )
                }),
                0
              )
            : _c("p", { staticClass: "vip-reward-empty" }, [
                _vm._v(_vm._s(_vm.$t("personalCenter.no_content"))),
              ]),
          _vm.selectedTier.level > 0
            ? [
                _c(
                  "p",
                  {
                    staticClass: "vip-reward-status",
                    class: { "is-unlocked": _vm.isSelectedTierUnlocked },
                  },
                  [
                    _c("i", {
                      class: _vm.isSelectedTierUnlocked
                        ? "el-icon-circle-check"
                        : "el-icon-lock",
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._v(
                      "\n\t\t\t\t" +
                        _vm._s(
                          _vm.$t(
                            _vm.isSelectedTierUnlocked
                              ? "personalCenter.vip.unlocked"
                              : "personalCenter.vip.locked",
                            {
                              level: _vm.selectedTier.level,
                            }
                          )
                        ) +
                        "\n\t\t\t"
                    ),
                  ]
                ),
                _c(
                  "button",
                  {
                    staticClass: "vip-claim-button",
                    attrs: {
                      type: "button",
                      disabled:
                        !_vm.isSelectedTierUnlocked ||
                        _vm.isSelectedTierClaimed ||
                        _vm.isClaimingReward,
                      "aria-busy": _vm.isClaimingReward ? "true" : "false",
                    },
                    on: { click: _vm.claimReward },
                  },
                  [
                    _vm.isClaimingReward
                      ? _c("i", {
                          staticClass: "el-icon-loading",
                          attrs: { "aria-hidden": "true" },
                        })
                      : _vm._e(),
                    _vm._v(
                      "\n\t\t\t\t" +
                        _vm._s(
                          _vm.$t(
                            _vm.isClaimingReward
                              ? "personalCenter.vip.claiming"
                              : _vm.isSelectedTierClaimed
                              ? "personalCenter.vip.claimed"
                              : "personalCenter.vip.claim"
                          )
                        ) +
                        "\n\t\t\t"
                    ),
                  ]
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "vip-level-mark", attrs: { "aria-hidden": "true" } },
      [_c("span", [_vm._v("VIP")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "vip-level-mark", attrs: { "aria-hidden": "true" } },
      [_c("span", [_vm._v("VIP")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }